module.exports = __webpack_public_path__ + "static/media/indaver.1f327de3.jpg";